// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"secondaryNav-module--wrapper--2ql-p","alignRight":"secondaryNav-module--alignRight--2vFuL"};